import { ImpactArgs, NotifyArgs } from './types';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const hapticImpact = (args: ImpactArgs = {}) => {
  // eslint-disable-next-line no-console
  console.debug(`Haptic ${args.style} impact triggered`);
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const hapticNotification = (args: NotifyArgs) => {
  // eslint-disable-next-line no-console
  console.debug(`Haptic ${args.type} notification triggered`);
};
